module.exports = __webpack_public_path__ + "img/9788974834128.d900e9b6.jpg";